import { useEffect } from 'react';
import {
  WIZARD_STATUS_COMPLETE,
  WIZARD_STATUS_NOT_STARTED,
  WIZARD_STATUS_RESTARTED,
  WIZARD_STATUS_RESTARTING,
} from 'platform/site-wide/wizard';
import { WIZARD_STATUS } from '../constants';

const allowedWizardStatuses = [
  WIZARD_STATUS_COMPLETE,
  WIZARD_STATUS_NOT_STARTED,
  WIZARD_STATUS_RESTARTED,
  WIZARD_STATUS_RESTARTING,
];

/**
 * Persists a valid wizard status to session storage for subtask flow handling.
 *
 * @param {string} [status] The wizard status to persist. Values can be found in platform/site-wide/wizard.
 */
export function setSubtaskStatus(status) {
  if (!allowedWizardStatuses.includes(status)) {
    return;
  }
  window.sessionStorage.setItem(WIZARD_STATUS, status);
}

/**
 * On render, persists a valid wizard status to session storage for subtask flow handling. This is a convenience wrapper
 * around setSubtaskStatus that can be used in subtask pages to set the wizard status as a side effect of rendering the
 * page. Most use cases should use this function.
 *
 * @param {string} [status] The wizard status to persist. Values can be found in platform/site-wide/wizard.
 */
export default function useSubtaskStatusMarker(status) {
  useEffect(() => {
    setSubtaskStatus(status);
  }, [status]);
}
